import AppLayout from '@/layout/app/index.vue';
import MasterLayout from '@/layout/master/index.vue';

const appRoutes = [
	{
		path: '/',
		component: AppLayout,
		name: 'AppHome',
		children: [
			{
				path: '/',
				name: 'homepage',
				component: () => import('@/pages/app/index/index.vue')
			},
			{
				path: '/product/:id',
				name: 'product',
				component: () => import('@/pages/app/product/index.vue')
			},
			{
				path: '/reg',
				name: 'register',
				component: () => import('@/pages/app/reg/index.vue')
			},
			{
				path: '/login',
				name: 'login',
				component: () => import('@/pages/app/login/index.vue')
			},
			{
				path: '/suggest',
				name: 'suggest',
				component: () => import('@/pages/app/suggest/index.vue')
			},
			{
				path: '/about',
				name: 'about',
				component: () => import('@/pages/app/about/index.vue')
			},
			{
				path: '/news/:id',
				name: 'NewsDetail',
				component: () => import('@/pages/app/news/detail.vue')
			},
			{
				path: '/news',
				name: 'news',
				component: () => import('@/pages/app/news/index.vue')
			},
			{
				path: '/job/:id',
				name: 'JobDetail',
				component: () => import('@/pages/app/job/detail.vue')
			},
			{
				path: '/corp',
				name: 'corp',
				component: () => import('@/pages/app/corp/index.vue')
			}
		]
	}
];

const masterRoutes = [
	{
		path: '/',
		component: MasterLayout,
		isMenu: true,
		name: 'MasterHome',
		meta: {
			title: '首页',
			icon: 'el-icon-s-home'
		},
		children: [
			{
				path: '/',
				name: 'homepage',
				component: () => import('@/pages/master/index/index.vue')
			}
		]
	},
	{
		path: '/offer',
		component: MasterLayout,
		name: 'MasterOffer',
		isMenu: true,
		meta: {
			title: '今日产品报价',
			icon: 'el-icon-s-marketing'
		},
		children: [
			{
				path: '/',
				name: 'OfferIndex',
				component: () => import('@/pages/master/offer/index.vue')
			},
			{
				path: 'order',
				name: 'OfferOrder',
				component: () => import('@/pages/master/offer/order.vue')
			},
			{
				path: ':id',
				name: 'OfferIndex',
				component: () => import('@/pages/master/offer/index.vue')
			}
		]
	},
	{
		path: '/shopping',
		component: MasterLayout,
		name: 'MasterShopping',
		isMenu: true,
		meta: {
			title: '购物车',
			icon: 'el-icon-s-claim'
		},
		children: [
			{
				path: '/',
				name: 'ShoppingIndex',
				component: () => import('@/pages/master/shopping/index.vue')
			},
			{
				path: 'payment/:id',
				name: 'ShoppingPayment',
				isMenu: false,
				component: () => import('@/pages/master/shopping/payment.vue'),
			}
		]
	},
	{
		path: '/order',
		component: MasterLayout,
		isMenu: true,
		name: 'MasterOrder',
		meta: {
			title: '订单管理',
			icon: 'el-icon-s-goods'
		},
		children: [
			{
				path: 'index',
				name: 'OrderIndex',
				isMenu: true,
				meta: {
					title: '所有订单',
				},
				component: () => import('@/pages/master/order/index.vue'),
			},
			{
				path: 'progress',
				name: 'OrderOrogress',
				isMenu: true,
				meta: {
					title: '订单加工进程',
				},
				component: () => import('@/pages/master/order/progress.vue'),
			},
			{
				path: 'yearly',
				name: 'OrderYearly',
				isMenu: true,
				meta: {
					title: '年度订单',
				},
				component: () => import('@/pages/master/order/yearly.vue'),
			},
			{
				path: 'detail/:id',
				name: 'OrderDetail',
				isMenu: false,
				component: () => import('@/pages/master/order/detail.vue'),
			},
			{
				path: 'payDetail/:id',
				name: 'OrderPayDetail',
				isMenu: false,
				component: () => import('@/pages/master/order/payDetail.vue'),
			}
		]
	},
	{
		path: '/invoice',
		component: MasterLayout,
		isMenu: true,
		name: 'MasterInvoice',
		meta: {
			title: '发票管理',
			icon: 'el-icon-s-ticket'
		},
		children: [
			{
				path: 'index',
				name: 'InvoiceIndex',
				isMenu: true,
				meta: {
					title: '发票列表',
				},
				component: () => import('@/pages/master/invoice/index.vue'),
			},
			{
				path: 'apply',
				name: 'InvoiceApply',
				isMenu: true,
				meta: {
					title: '发票申请',
				},
				component: () => import('@/pages/master/invoice/apply.vue'),
			},
			{
				path: 'detail/:id',
				name: 'InvoiceDetail',
				isMenu: false,
				component: () => import('@/pages/master/invoice/detail.vue'),
			}
		]
	},
	{
		path: '/account',
		component: MasterLayout,
		name: 'MasterAccount',
		isMenu: true,
		meta: {
			title: '账号管理',
			icon: 'el-icon-user-solid'
		},
		children: [
			{
				path: 'index',
				name: 'AccountIndex',
				isMenu: true,
				meta: {
					title: '账号信息',
				},
				component: () => import('@/pages/master/account/index.vue'),
			},
			{
				path: 'password',
				name: 'AccountPassword',
				isMenu: true,
				meta: {
					title: '设置密码',
				},
				component: () => import('@/pages/master/account/password.vue'),
			},
		]
	}

];

const config = {
	'www': {
		checkToken: false,
		routes: appRoutes
	},
	'master': {
		checkToken: true,
		routes: masterRoutes
	},
};


const routes = [
	{
		path: '/404',
		component: () => import('@/pages/app/error/404.vue'),
		isMenu: false
	},
	{ path: '*', name: 'page404', redirect: '/404', isMenu: false }
];


export default {
	routes,
	config,
};




// WEBPACK FOOTER //
// ./src/config/router.js